interface WasteTypeProps {
  name: string
  picture?: string
  id: string
}

class WasteType {
  public readonly picture?: string
  public readonly name: string
  public readonly id: string

  constructor({ picture, name, id }: WasteTypeProps) {
    this.id = id
    this.name = name
    this.picture = picture

  }


}

export default WasteType
